<!-- FILTER + TEXT SECTION -->
<section class="p-24px bg-off-white rounded-12px">
	<div class="flex justify-between items-center mb-16px">
		<h1 class="mb-0 mt-5">
			{{ 'WALLET.SP_WALLET.HISTORY' | translate }}
		</h1>
		<app-search-filter
			(toggleFilter)="sidenav.toggle()"
			[showSearch]="false"
			[filterCount]="filterCount"
			(resetFilter)="filter.resetFilter()"
		></app-search-filter>
	</div>
	<!-- DATA SECTION  -->
	<div class="py-12px bg-[#F5F5F5] rounded-[16px]">
		<div
			*ngFor="
				let last = last;
				let record;
				of: walletHistoryList
					| paginate
						: {
								itemsPerPage: walletFilter?.paging?.pageSize,
								currentPage: walletFilter?.paging?.pageNumber,
								totalItems: totalCount
						  }
			"
		>
			<div
				class="ltr:pl-16px ltr:pr-24px rtl:pl-24px rtl:p-16px py-12px flex content-between"
			>
				<img
					class="ltr:mr-16px rtl:ml-16px"
					src="./assets/images/{{
						record?.operation == 0
							? 'fund-down-arrow-green.svg'
							: 'cancel-element.svg'
					}}"
					alt=""
				/>
				<div class="flex-grow-[2]">
					<h1 class="text-dark-grey text-font-16 mb-0">
						{{
							translate?.currentLang == 'en'
								? record?.title?.en
								: record?.title?.ar
						}}
					</h1>
					<p class="text-medium-gray text-font-12 mb-0">
						{{ record?.transactionDate | date : 'dd/MM/yyyy hh:mm a' : 'UTC' }}
					</p>
					<p class="text-medium-gray text-font-12 mb-0">
						{{
							translate?.currentLang == 'en'
								? record?.description?.en
								: record?.description?.ar
						}}
					</p>
				</div>
				<div class="flex flex-col">
					<h1
						class="text-font-14 font-DIN-bold font-bold {{
							record?.operation == 0 ? 'text-success-green' : 'text-dark-pink'
						}} {{ !record?.isPending ? 'ltr:mr-[23px]' : 'rtl:ml-[23px]' }}"
					>
						{{
							translate?.currentLang == 'en'
								? record?.currency?.name?.en
								: record?.currency?.name?.ar
						}}
						{{ record?.operation == 0 ? '+' : '-' }}{{ record?.amount }}
					</h1>
					<div *ngIf="record?.isPending" class="flex items-center">
						<svg width="16" height="16" viewBox="0 0 16 16" class="mx-[4px]">
							<path
								d="M7.99992 15.1668C4.04659 15.1668 0.833252 11.9535 0.833252 8.00016C0.833252 4.04683 4.04659 0.833496 7.99992 0.833496C11.9533 0.833496 15.1666 4.04683 15.1666 8.00016C15.1666 11.9535 11.9533 15.1668 7.99992 15.1668ZM7.99992 1.8335C4.59992 1.8335 1.83325 4.60016 1.83325 8.00016C1.83325 11.4002 4.59992 14.1668 7.99992 14.1668C11.3999 14.1668 14.1666 11.4002 14.1666 8.00016C14.1666 4.60016 11.3999 1.8335 7.99992 1.8335Z"
								fill="#6E7191"
							/>
							<path
								d="M10.4733 10.6202C10.3867 10.6202 10.3 10.6002 10.22 10.5468L8.15334 9.3135C7.64001 9.00684 7.26001 8.3335 7.26001 7.74017V5.00684C7.26001 4.7335 7.48668 4.50684 7.76001 4.50684C8.03334 4.50684 8.26001 4.7335 8.26001 5.00684V7.74017C8.26001 7.98017 8.46001 8.3335 8.66668 8.4535L10.7333 9.68684C10.9733 9.82684 11.0467 10.1335 10.9067 10.3735C10.8067 10.5335 10.64 10.6202 10.4733 10.6202Z"
								fill="#6E7191"
							/>
						</svg>
						<p class="text-font-12 text-medium-gray mb-0">
							{{ 'STATUS.EXPECTED' | translate }}
						</p>
					</div>

					<div
						*ngIf="record?.reason != null"
						(click)="viewReason(record)"
						class="flex items-center"
					>
						<span
							class="inline-block max-mobile:w-[20px] w-[16px] text-end mx-2"
						>
							<img
								class="inline-block cursor-pointer"
								[src]="'assets/images/view.svg'"
								alt=""
							/>
						</span>
						<p class="text-font-12 text-medium-gray mb-0">
							{{ 'GENERAL_LABELS.REASON' | translate }}
						</p>
					</div>
				</div>
			</div>
			<!-- SEPARATOR -->
			<div *ngIf="!last" class="h-[1px] w-[96%] bg-[#D9DBE9] m-auto"></div>
			<!-- SEPARATOR -->
		</div>
	</div>
	<!-- DATA SECTION  -->

	<!-- PAGINATION  -->
	<div class="mt-8 max-mobile:overflow-auto">
		<app-pagination
			[totalCount]="totalCount"
			[pageNumber]="walletFilter.paging.pageNumber"
			[pageCount]="walletFilter.paging.pageSize"
			(currentPage)="pagingChanged($event, walletFilter.paging.pageSize)"
			(itemsCountPerPage)="pagingChanged(1, $event)"
			[smallSize]="true"
		></app-pagination>
	</div>
	<!-- PAGINATION  -->
</section>
<ng-container>
	<mat-sidenav-container [hasBackdrop]="true" class="z-20">
		<mat-sidenav
			position="end"
			#sidenav
			mode="side"
			opened
			class="max-w-[428px] bg-white text-dark-grey p-12px min-h-screen"
			[fixedInViewport]="true"
			[fixedTopGap]="0"
			[disableClose]="false"
			[fixedBottomGap]="0"
			[disableClose]="false"
			[opened]="false"
		>
			<header class="tw-p-4 p-12px">
				<div class="rtl:text-left ltr:text-right">
					<button (click)="sidenav.toggle()">
						<img src="./assets/images/close-square.svg" alt="" />
					</button>
				</div>
			</header>
			<app-sp-wallet-filter
				#filter
				[filterData]="walletFilter"
				(emitFilter)="getWalletHistoryList($event); sidenav.toggle()"
				(emitfilterCount)="filterCount = $event"
			></app-sp-wallet-filter>
		</mat-sidenav>
	</mat-sidenav-container>
</ng-container>

<!-- FILTER + TEXT SECTION -->
